// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator audit_log`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import employees from 'modules/employees/store/collections/employees'
import features from 'modules/core/store/collections/features'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [employees, {}] /* Referenced by 1 cases in this module */,
    [features, {}] /* Referenced by 2 cases in this module */,
  ] /* Generated file 👉 artifacts/audit_log-module-settings.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
